import React, { useEffect, useRef } from 'react'

const servicesData = [
  {
    title: 'IT-advies & projectbegeleiding',
    description:
      'Ik breng in kaart wat u nodig heeft, zoek de juiste leveranciers erbij en begeleid de uitvoering. U hoeft zelf niet de samenhang te bewaken.',
  },
  {
    title: 'Maatwerk websites',
    description:
      'Van een eenvoudige presentatiesite tot een volledig maatwerk platform. Ik kijk mee welke aanpak past en begeleid het traject.',
  },
  {
    title: 'Hosting & DNS-regie',
    description:
      'Ik zoek de juiste hostingpartij, regel domein, DNS en SSL en houd de regie. Geen omkijken naar voor u.',
  },
  {
    title: 'Support & onderhoud',
    description:
      'Updates, back-ups en troubleshooting. Bij een storing pak ik het snel op, zelf of via iemand in mijn netwerk, en ik leg uit wat er is gebeurd.',
  },
  {
    title: 'Beveiliging',
    description:
      'Wachtwoordbeleid, 2FA en phishing-checks. Ik kijk wat uw situatie vraagt en doe wat er echt nodig is.',
  },
  {
    title: 'Systeemintegraties & koppelingen',
    description:
      'Twee systemen die met elkaar moeten praten? Ik zoek de juiste specialist, zit erbij tijdens de technische gesprekken en zorg dat de koppeling ook echt werkt.',
  },
]

const Services: React.FC = () => {
  const listRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const list = listRef.current
    if (!list) return

    const rows = Array.from(list.querySelectorAll<HTMLElement>('.reveal'))

    const show = () => rows.forEach((row) => row.classList.add('is-visible'))

    const fallback = setTimeout(show, 1500)

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          show()
          clearTimeout(fallback)
          observer.disconnect()
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' },
    )

    observer.observe(list)
    return () => {
      clearTimeout(fallback)
      observer.disconnect()
    }
  }, [])

  return (
    <section id="diensten" className="py-16 sm:py-20 bg-brand-primary">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 flex flex-col sm:flex-row sm:items-baseline sm:gap-10">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-ink shrink-0">
            Diensten
          </h2>
          <p className="mt-2 sm:mt-0 text-brand-muted">
            Van advies tot websites en systeemkoppelingen: u heeft één technisch
            aanspreekpunt.
          </p>
        </div>

        <div ref={listRef} className="divide-y divide-brand-ink/10">
          {servicesData.map((service, index) => (
            <div
              key={service.title}
              className="reveal group py-6 sm:py-7 grid sm:grid-cols-[2fr_3fr] gap-1 sm:gap-16 items-baseline"
              style={{ '--i': index } as React.CSSProperties}
            >
              <h3 className="text-base sm:text-lg font-semibold text-brand-ink group-hover:text-brand-accent transition-colors duration-150">
                {service.title}
              </h3>
              <p className="text-sm sm:text-base text-brand-muted group-hover:text-brand-ink leading-relaxed transition-colors duration-150">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
